<template>
  <div class='scroll-list-wrapper' :class="darkClass">
    <van-tabs class="fixed-box" @click="changeTabs">
      <van-tab v-for="item in tabsList" :title="item.name" :key="item.id" :name="item.id"></van-tab>
    </van-tabs>
    <div class="content">
      <van-loading v-if="eventLoading" size="20px">加载中...</van-loading>
      <van-list ref="list" v-else v-show="eventList.length" v-model="afficheFilter.isFetchingMore"
        :finished="afficheFilter.finished" :immediate-check="false" :error.sync="afficheFilter.error" error-text="查看更多"
        @load="onLoad">
        <div class="notice-wrapper-box">
          <event-list :eventList="eventList"></event-list>
        </div>
      </van-list>
      <van-empty v-if="!eventLoading && !eventList.length" description="暂无数据" />
    </div>
    <div class="disclaimer">{{ disclaimer }}</div>
  </div>
</template>

<script>
import { disclaimer } from './utils/article';
import { List, Icon, Empty, Toast, Loading, Tab, Tabs } from 'vant';
import {
  event_list,
  event_tabs,
} from '@/api/b2b-news';
import { isDark } from './utils/oemUtils';
import event from './components/event.vue';

export default {
  name: '',
  components: {
    [event.name]: event,
    [Empty.name]: Empty,
    [Toast.name]: Toast,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [Icon.name]: Icon,
    [Loading.name]: Loading,
  },
  computed: {
    darkClass() {
      return isDark() ? 'dark' : '';
    }
  },
  data() {
    return {
      tabsList: [
        { id: 'all', name: '全部大事' },
        { id: 'finance', name: '财务披露' },
        { id: 'dividend', name: '分红融资' },
        { id: 'equity', name: '股权变动' },
        { id: 'trading', name: '交易提示' },
        { id: 'operations', name: '经营运作' },
        { id: 'risk', name: '风险提示' },
        { id: 'other', name: '其他事项' },
      ],
      eventList: [],
      eventLoading: true,
      afficheFilter: {
        page: 0,
        pageSize: 20,
        isFetchingMore: false,
        finished: false,
        error: false,
        cate: 'all',
      },
      disclaimer,
    };
  },
  mounted() {
    this.fetchEventsTabs();
  },
  methods: {
    changeShowDetail(item) {
      if (typeof item.showDetail === 'undefined' || item.showDetail === null) {
        this.$set(item, 'showDetail', true);
      } else {
        item.showDetail = !item.showDetail;
      }
    },
    changeTabs(val) {
      if (val !== this.afficheFilter.cate) {
        this.afficheFilter.page = 0;
        this.afficheFilter.cate = val;
        this.eventLoading = true;
        this.eventList = [];
        this.fetchEventsList().finally(() => {
          this.eventLoading = false;
        });
      }
    },
    onLoad() {
      if (this.afficheFilter.finished) {
        return;
      }
      this.afficheFilter.page += 1;
      this.afficheFilter.isFetchingMore = true;
      this.fetchEventsList().finally(() => {
        this.afficheFilter.isFetchingMore = false;
      });
    },
    /**
     * @description 大事提醒
     */
    fetchEventsList() {
      const { page, pageSize, cate } = this.afficheFilter;
      const { stock, accessKey } = this.$route.query;
      return event_list({
        accessKey,
        stock,
        cate,
        page,
        pageSize,
      }).then(res => {
        this.eventLoading = false;
        if (res.code === 0 && res.data && res.data.length) {
          const arr = this.eventList.slice(0);
          res.data.forEach(item => {
            // 屏蔽标题跳转
            item.jumpUrl = '';
            item.showExpand = false;
            arr.push(item);
          });
          this.eventList = arr;
          // 如果数量与pageSize相同则证明还有下一页。
          this.afficheFilter.error = res.data.length === pageSize;
          this.afficheFilter.finished = res.data.length !== pageSize;
        } else {
          this.afficheFilter.error = false;
          this.afficheFilter.finished = true;
        }
      }).catch(() => {
        this.afficheFilter.error = false;
        this.afficheFilter.finished = true;
      });
    },
    /**
     * @description  页签
     */
    fetchEventsTabs() {
      const { accessKey } = this.$route.query;
      event_tabs({
        accessKey
      }).then(res => {
        const { code, data } = res;
        if (code === 0) {
          const arr = [{ id: 'all', name: '全部大事' }].concat(data);
          this.tabsList = arr;
        }
        this.fetchEventsList();
      });
    },
  },
};
</script>
<style lang='less' scoped>
.scroll-list-wrapper {
  min-height: 100vh;

  .jump-affiche-detail {
    display: inline-block;
    margin-left: 6px;
    color: #4e88ff;
  }
}

.content {
  min-height: 100vh;
  height: 100%;
  padding-top: 50px;
  background: #fff;
}

.fixed-box {
  position: fixed;
  border-bottom: 1px solid #EFEFEF;
  width: 100%;
  z-index: 100;
}

.notice-wrapper-box {
  padding-bottom: 10px;
}

.van-loading {
  line-height: 100px;
  text-align: center;
}

.disclaimer {
  padding: 20px;
  line-height: 22px;
  font-size: 12px;
  color: #a3a3a3;
}

.dark {
  .content {
    background-color: @dark-color-bg-page;

    .tabs-box {
      background-color: #252525;

      .tabs-item {
        color: @dark-color-text-gray;

        &::after {
          background-color: #333333;
        }

        &.active {
          color: #d2d2d2;
          background-color: #323232;
        }
      }
    }
  }

  .news-list .news-list-item-wrapper+.news-list-item-wrapper .news-list-item {
    .hairline("top", #313131);
  }

  .news {
    background-color: @dark-color-bg-page;

    .item-info-title {
      color: @dark-color-text-primary;
    }

    .item-info-meta {
      color: @dark-color-text-gray;
    }
  }

  // 大事提醒
  .main-title {
    color: @dark-color-text-primary;

    &-btn {
      color: @dark-color-text-primary;
    }
  }

  .fixed-box {
    border-bottom: 1px solid #020202;
  }

  .disclaimer {
    color: #8E8E8E;
    background-color: @dark-color-bg-page;
  }
}
</style>
<style lang="less">
.van-tabs__line {
  width: 20px;
  background-color: #DF3840;
}

.van-tab {
  color: #646464;
}

.van-tab--active {
  font-size: 16px;
  color: #DF3840;
}

.dark {
  .scroll-list-wrapper {
    background-color: #333;
  }

  .van-tabs__nav {
    background-color: @dark-color-bg-page;
  }

  .van-tab {
    color: #d2d2d3;
  }

  .van-tab--active {
    color: #DF3840;
  }
}
</style>
